import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["partId", "price", "description", "descriptionEn", "salesDeText", "salesEnText", "ownership", "customsCode", "countryOfOrigin", "unitWeight", "declaredValue"]

  connect() {
    this.ownershipTarget.hidden = !!this.partIdTarget.value
  }

  select(event) {
    const article = JSON.parse(event.detail.selected.dataset.stockArticle)
    this.ownershipTarget.hidden = true
    this.customsCodeTarget.value = article.customsCode ?? ""
    this.countryOfOriginTarget.value = article.countryOfOrigin ?? ""
    this.unitWeightTarget.value = article.unitWeight ?? ""
    this.declaredValueTarget.value = ""
    this.priceTarget.value = article.price ?? ""
    this.descriptionTarget.value = article.description ?? ""
    this.descriptionEnTarget.value = article.descriptionEn ?? ""
    this.setText(this.salesDeTextTarget, article.salesDeText)
    this.setText(this.salesEnTextTarget, article.salesEnText)
  }

  clearArticle() {
    // Clear immediately; autocomplete clears its ID only after its debounce.
    this.ownershipTarget.hidden = false
    // Preserve manual descriptions when searching without a previously selected article.
    if (!this.partIdTarget.value) return
    this.customsCodeTarget.value = ""
    this.countryOfOriginTarget.value = ""
    this.unitWeightTarget.value = ""
    this.declaredValueTarget.value = ""
    this.partIdTarget.value = ""
    this.priceTarget.value = ""
    this.descriptionTarget.value = ""
    this.descriptionEnTarget.value = ""
    this.setText(this.salesDeTextTarget, "")
    this.setText(this.salesEnTextTarget, "")
  }

  setText(target, html) {
    if (target.editor) {
      target.editor.loadHTML(html || "")
    } else {
      target.value = html || ""
    }
  }
}
